<template>
    <header-dropdown position="right">
        <template v-slot:button>
            <a href="javascript:;" class="k-menu__link position-relative">
                <svg class="k-menu__link-icon" role="img" width="25" height="22">
                    <use fill="currentColor" xlink:href="/images/spritesheet.svg#notification"/>
                </svg>

                <div v-if="notificationsCount > 0" class="k-notification-badge">
                    {{ notificationsCount }}
                </div>
            </a>
        </template>

        <template v-slot:dropdown>
            <div class="k-notification-dropdown">
                <template v-if="notifications.length === 0">
                    <a class="k-notification-dropdown__item justify-content-center">Nemáte žádná nová upozornění</a>
                </template>

                <template v-else>

                    <a v-for="notification in notifications" class="k-notification-dropdown__item">

                        <div v-if="notification.causer !== null" class="k-notification-dropdown__image">
                            <img :src="notification.causer.image || '/images/placeholder.png'" alt="">
                        </div>

                        <div class="k-notification-dropdown__text">

                            <template v-if="notification.causer !== null">

                                <template v-if="notification.causer.url !== null">
                                    <a :href="notification.causer.url">
                                        <strong class="k-strong">{{ notification.causer.name }}</strong>
                                    </a>
                                </template>

                                <template v-else>
                                    <strong>{{ notification.causer.name }}</strong>
                                </template>

                            </template>

                            {{ notification.text }}

                            <template v-if="notification.subject !== null">

                                <template v-if="notification.subject.url !== null">
                                    <a :href="notification.subject.url">
                                        <strong class="k-strong">{{ notification.subject.title }}</strong>
                                    </a>
                                </template>

                                <template v-else>
                                    <strong>{{ notification.subject.title }}</strong>
                                </template>

                            </template>

                        </div>

                    </a>

                </template>

                <a :href="notificationsListLink" class="k-user-dropdown__item k-user-dropdown__item--show-all">
                    Zobrazit všechny
                </a>
            </div>
        </template>
    </header-dropdown>

</template>

<script>
    import HeaderDropdown from './HeaderDropdown';
    export default {
        components: {
            'header-dropdown': HeaderDropdown
        },
        props: {
            url: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                notificationsCount: false,
                notifications: []
            }
        },

        computed: {
            /**
             * Get notifications list link
             *
             * @return string
             */
            notificationsListLink: function() {
                return Links.notificationsList;
            }
        },

        methods: {
            /**
             * Fetch notifications
             *
             * @return void
             */
            fetchNotifications: async function() {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.url
                    });
                    if (result.status === 200 && result.data) {
                        this.notifications = result.data.notifications;
                        this.notificationsCount = result.data.totalCount;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            }
        },
        mounted() {
            // fetch notifications
            this.fetchNotifications();

            // fetch notifications every 30 seconds
            setInterval(() => {
                this.fetchNotifications();
            }, 30000);
        }
    }
</script>
